// Merge the API's worker rows with the full non-owner staff list so every member
// is shown even with no hours. `zero` supplies the empty-row totals for that page.
// `hasAccess` (optional) filters which staff get injected as zero-rows by their
// Operational Access. Staff who already have real recorded hours are always shown,
// even if their access type contradicts the page.
export const hasConnect = (a) => a === "CONNECT_ONLY" || a === "CONNECT_FIELD";
export const hasField = (a) => a === "FIELD_ONLY" || a === "CONNECT_FIELD";

export function mergeStaff(apiWorkers, users, idKey, nameKey, zero, hasAccess) {
  const list = apiWorkers || [];
  const byId = new Map(list.map((w) => [w[idKey], w]));
  const active = (users || []).filter((u) => u.role !== "owner" && !["inactive", "archived", "disabled", "suspended"].includes(u.status));
  const staff = hasAccess ? active.filter((u) => hasAccess(u.operationalAccess || "CONNECT_ONLY")) : active;
  const out = staff.map((u) => byId.get(u.id) || { [idKey]: u.id, [nameKey]: u.displayName, days: [], colour: u.calendarColour, ...zero });
  const staffIds = new Set(staff.map((u) => u.id));
  list.forEach((w) => { if (!staffIds.has(w[idKey])) out.push(w); });
  out.sort((a, b) => (a[nameKey] || "").localeCompare(b[nameKey] || "", undefined, { sensitivity: "base" }));
  return out;
}
